import { OrgTypeWithRole } from 'src/@types/org';
import { Role } from 'src/@types/role';
import OrgSwitcherRowBase from './OrgSwitcherRowBase';

type AcceptedOrgRowProps = {
  org: OrgTypeWithRole;
  onSelectOrg: (org: OrgTypeWithRole, role: Role | undefined) => void;
};

export default function AcceptedOrgRow({ org, onSelectOrg }: AcceptedOrgRowProps) {
  return <OrgSwitcherRowBase org={org} onClick={() => onSelectOrg(org, org.user_org_role)} />;
}
